
import React from 'react'

import useTranslation from '@/Hooks/UseTranslation'

import './WeekNavigator.scss'

interface Props {
  prev: string
  next: string
  current: string | number
  onChangeWeek: (week?: string) => void
}

const WeekNavigator = (props: Props) => {

  const { prev, next, current, onChangeWeek } = props

  const { t } = useTranslation()

  return (
    <div className="week-navigator">
      <button
        className={`btn btn-link btn-navigator btn-prev ${!prev && 'disabled'}`}
        onClick={() => onChangeWeek && onChangeWeek(prev)}
        aria-label={t('RESOURCES_CNC:ToolbarPreviousButton')}
        title={t('RESOURCES_CNC:ToolbarPreviousButton')}
      >
        <i className="icon-anterior"></i>
        <span className="d-none d-md-inline"> {t('RESOURCES_CNC:ToolbarPreviousButton')}</span>
      </button>
      <button
        className="btn btn-link btn-navigator btn-current"
        onClick={() => onChangeWeek && onChangeWeek()}
        aria-label={t('SYSTEM:CurrentWeekButton')}
        title={t('SYSTEM:CurrentWeekButton')}
      >
        <i className="icon-semana_actual"></i>
      </button>
      <button
        className={`btn btn-link btn-navigator btn-next ${!next && 'disabled'}`}
        onClick={() => onChangeWeek && onChangeWeek(next)}
        aria-label={t('RESOURCES_CNC:ToolbarNextButton')}
        title={t('RESOURCES_CNC:ToolbarNextButton')}
      >
        <span className="d-none d-md-inline">{t('RESOURCES_CNC:ToolbarNextButton')} </span>
        <i className="icon-siguiente"></i>
      </button>
    </div>
  )
}

export default WeekNavigator
